import { render, staticRenderFns } from "./purchasingAccess.vue?vue&type=template&id=0a954e0c"
import script from "./purchasingAccess.vue?vue&type=script&lang=js"
export * from "./purchasingAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports